import CodeBox from '@editorjs/code'; // 原始 CodeBox 插件


export default class CustomCodeBox extends CodeBox {
    constructor({ data, api, readOnly, config }) {
        // 确保传递所有必要的配置项给父类构造函数
        super({ data, api, readOnly, config });
        this.readOnly = readOnly;
    }

  render() {
    const container = super.render();

    if (this.readOnly) {
      // 只读模式下，禁用编辑功能
      const textarea = container.querySelector('textarea');
      if (textarea) {
        textarea.disabled = true;
        textarea.style.backgroundColor = '#f5f5f5'; // 可选：设置只读背景色
      }

      // 或者直接替换为只读的 <pre><code> 元素
      const code = this.data.code || '';
      container.innerHTML = `<pre><code>${code}</code></pre>`;
    }

    return container;
  }
}